import React from 'react';
import { Button as AntdButton, ConfigProvider } from 'antd';
import { colorPalette, theme } from 'shared/constants';

/**
 * @typedef {import('antd').ButtonProps} ButtonProps
 */

/**
 * @param {ButtonProps} props
 * @returns {React.ReactNode}
 */
export function Button({ children, type, ...props }) {
  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            //type default
            colorBgContainer: 'transparent',
            colorPrimaryText: colorPalette.primaryMain6,
            colorPrimary: colorPalette.primaryMain6,
            colorPrimaryHover: colorPalette.primaryMain5,
            colorPrimaryTextHover: colorPalette.primaryMain5,
            colorBorder: colorPalette.primaryMain6,
            colorText: colorPalette.primaryMain6,
            colorTextHover: colorPalette.primaryMain6,
            colorBorderSecondary: colorPalette.primaryMain5,
            colorBorderSecondaryHover: colorPalette.primaryMain6,
            borderColorDisabled: colorPalette.neutral4,
            colorLink: colorPalette.primaryMain6,
            colorLinkHover: colorPalette.primaryMain5,
          },
        },
        token: {
          fontFamily: theme.newFontFamily,
        },
      }}>
      <AntdButton type={type === 'danger' ? 'default' : type} danger={type === 'danger'} {...props}>
        {children}
      </AntdButton>
    </ConfigProvider>
  );
}
